<template>
  <v-container fluid class="pa-4">
    <v-card class="rounded-lg" elevation-3>
      <v-overlay :value="isLoading || $store.state.loading_pdf" opacity="0.8">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card-title class="d-flex align-center">
        <v-icon large left>mdi-account-cash</v-icon>
        <span class="headline">Relatório de Devedores</span>
      </v-card-title>

      <v-card-text>
        <v-row class="mb-4" align="center">
          <v-col cols="12" sm="6" md="3">
            <v-combobox v-model="anoLectivoSelected" :items="Listaranoslectivo" label="Ano Lectivo"
              @change="limparLista()" item-value="anolectivo" item-text="novadescricao" outlined dense hide-details
              prepend-icon="mdi-calendar" class="rounded-lg"></v-combobox>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-combobox v-model="classeSeleted" label="Classe" item-value="id" item-text="descricao"
              @change="limparLista()" :items="ClassesAll" return-object outlined dense hide-details
              prepend-icon="mdi-school" class="rounded-lg"></v-combobox>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-combobox v-model="mesSelected" label="Mês inicial" item-value="id_mes" item-text="descricao"
              @change="limparLista()" :items="ListaMeses" return-object outlined dense hide-details
              prepend-icon="mdi-calendar-month" class="rounded-lg"></v-combobox>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-combobox v-model="mesSelected2" label="Mês Final" item-value="id_mes" item-text="descricao"
              @change="limparLista()" :items="ListaMeses" return-object outlined dense hide-details
              prepend-icon="mdi-calendar-month" class="rounded-lg"></v-combobox>
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-combobox v-if="devedoresSelected.length" v-model="turmaSelected" label="Turmas" item-value="descricao"
              item-text="descricao" @change="filtrarTurmas()" :items="listaTurmas" return-object outlined dense
              hide-details prepend-icon="mdi-account-group" class="rounded-lg"></v-combobox>
          </v-col>

          <v-col cols="12" sm="6" md="1" class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" fab small v-bind="attrs" v-on="on" @click="carregarDevedores()"
                  :disabled="!camposValidos">
                  <v-icon>search</v-icon>
                </v-btn>
              </template>
              <span>Pesquisar devedores</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <div v-if="devedoresSelected.length" class="d-flex justify-space-between mb-4">
          <div class="text-h6">
            Total de registros: {{ devedoresSelected.length }} |
            Total dívida: {{ utilitarios.IntegerToMoneyValueFatura(totaisObject.divida) }}
          </div>

          <div>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab small color="primary" class="mr-2" v-bind="attrs" v-on="on" @click="gerarHTML()">
                  <v-icon>print</v-icon>
                </v-btn>
              </template>
              <span>Imprimir relatório</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab small color="success" v-bind="attrs" v-on="on" @click="excelPrint()">
                  EX
                </v-btn>
              </template>
              <span>Exportar para Excel</span>
            </v-tooltip>
          </div>
        </div>

        <v-data-table v-if="devedoresSelected.length" :headers="headers" :items="devedoresSelected" :items-per-page="30"
          sort-by="data_" class="elevation-1 rounded-lg" :footer-props="{
            itemsPerPageOptions: [10, 20, 30, 50, 100],
            showFirstLastPage: true,
            showCurrentPage: true
          }">
          <template v-slot:item.index="{ item }">
            <span class="font-weight-medium">{{ devedoresSelected.indexOf(item) + 1 }}</span>
          </template>

          <template v-slot:item.anoacademico="{ item }">
            <v-chip small color="primary" outlined>
              {{ getClasse(item.anoacademico) }} Classe
            </v-chip>
          </template>

          <template v-slot:item.precoUnitario="{ item }">
            <span class="font-weight-bold">{{ utilitarios.IntegerToMoneyValueFatura(item.precoUnitario) }}</span>
          </template>

          <template v-slot:item.divida="{ item }">
            <span class="font-weight-bold error--text">{{ utilitarios.IntegerToMoneyValueFatura(item.divida) }}</span>
          </template>

          <template v-slot:no-data>
            <v-alert type="info" border="left" class="my-4">
              Nenhum dado encontrado para os critérios selecionados.
            </v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import axios from "../../plugins/axios";
const ls = require("local-storage");
import utilitarios from '../../plugins/utilitarios';
import impressaoService from '../../services/impressaoService';
import * as XLSX from 'xlsx';

export default {
  data: () => ({
    templateFull: null,
    utilitarios: utilitarios,
    Listaranoslectivo: [],
    anoLectivoSelected: null,
    turmaSelected: null,
    ClassesAll: [
      { id: 1, descricao: "10ª Classe" },
      { id: 2, descricao: "11ª Classe" },
      { id: 3, descricao: "12ª Classe" },
      { id: 4, descricao: "13ª Classe" },
    ],
    classeSeleted: null,
    ListaMeses: [],
    mesSelected: null,
    mesSelected2: null,
    devedores: [],
    devedoresSelected: [],
    headers: [
      { text: "#", value: "index", width: "5%", align: "center", sortable: false },
      { text: "Nome", value: "nome", width: "20%" },
      { text: "Matrícula", value: "matricula", width: "10%" },
      { text: "Curso", value: "curso", width: "15%" },
      { text: "Classe", value: "anoacademico", width: "10%", align: "center" },
      { text: "Turma", value: "turma", width: "10%", align: "center" },
      { text: "Meses", value: "meses", width: "10%" },
      { text: "Preço Unitário", value: "precoUnitario", width: "10%", align: "end" },
      { text: "Total Dívida", value: "divida", width: "10%", align: "end" },
    ],
    isLoading: true,
    config: null,
    turmasUnicas: [],
    listaTurmas: [],
  }),

  computed: {
    licencaExpirada() {
      return ls.get('licencaExpirada')
    },

    camposValidos() {
      return this.anoLectivoSelected && this.classeSeleted && this.mesSelected && this.mesSelected2
    },

    totaisObject() {
      let totais = { divida: 0 }
      this.devedoresSelected.forEach(element => {
        let divida = isNaN(element.divida) || !element.divida ? 0 : utilitarios.MoneyValueToInteger(element.divida);
        totais.divida += divida;
      });
      return totais
    },
  },

  created() {
    this.config = ls.get('configuracaoinstituicao');
    this.initializeAnosLectivo();
    this.initializeMeses();
    this.getTemplateRelatorio();
  },

  methods: {
    async initializeAnosLectivo() {
      this.isLoading = true;
      try {
        const response = await axios.get("/listarAnoLectivoAllFinancas");
        this.Listaranoslectivo = response.data;
      } catch (error) {
        this.showError("Erro ao carregar os anos lectivos!");
      } finally {
        this.isLoading = false;
      }
    },

    // Then update your excelPrint method:
    excelPrint() {
      if (!this.devedoresSelected.length) {
        this.showError("Nenhum dado para exportar!");
        return;
      }

      try {
        const exportData = this.devedoresSelected.map((item, index) => ({
          "#": index + 1,
          "Nome": item.nome,
          "Matrícula": item.matricula,
          "Curso": item.curso,
          "Classe": this.getClasse(item.anoacademico) + " Classe",
          "Turma": item.turma,
          "Meses": item.meses,
          "Preço Unitário": this.utilitarios.IntegerToMoneyValueFatura(item.precoUnitario),
          "Total Dívida": this.utilitarios.IntegerToMoneyValueFatura(item.divida),
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Devedores");

        const fileName = `Relatorio-Devedores-${new Date().toLocaleDateString('pt-BR').replace(/\//g, '-')}.xlsx`;
        XLSX.writeFile(workbook, fileName);
      } catch (error) {

        this.showError("Erro ao exportar para Excel");
      }
    },

    filtrarTurmas() {
      try {
        if (this.turmaSelected.descricao === "Todas as turmas") {
          this.devedoresSelected = this.devedores;
        } else {
          this.devedoresSelected = this.devedores.filter((d) => d.turma === this.turmaSelected.descricao);
        }
      } catch (error) {
        this.showError("Erro ao filtrar turmas");
      }
    },

    async getTemplateRelatorio() {
      try {
        this.isLoading = true;
        const response = await axios.get('/obterRelatorioByDescricao/dp');
        this.templateFull = response.data[0];
      } catch (error) {
        this.showWarning('Ocorreu um erro durante o carregamento do pdf do relatório!');
      } finally {
        this.isLoading = false;
      }
    },

    async gerarHTML() {
      if (this.licencaExpirada) {
        this.showInfo('A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!');
        return;
      }

      this.$store.state.loading_pdf = true;

      try {
        let template = this.templateFull.documento;
        let relatorioDados = '';
        let c = 1;

        this.devedoresSelected.forEach(element => {
          let interacao1 = this.templateFull.documentoiteracao1;
          interacao1 = interacao1
            .replace('{{index}}', c++)
            .replace('{{nome}}', element.nome)
            .replace('{{matricula}}', element.matricula)
            .replace('{{curso}}', element.curso)
            .replace('{{classe}}', this.getClasse(element.anoacademico))
            .replace('{{turma}}', element.turma)
            .replace('{{meses}}', element.meses)
            .replace('{{P.Unit.}}', this.utilitarios.IntegerToMoneyValueFatura(element.precoUnitario))
            .replace('{{Total}}', this.utilitarios.IntegerToMoneyValueFatura(element.divida));

          relatorioDados += interacao1;
        });

        let dados = {
          '{{logoInstituicao}}': this.config.logo,
          '{{nomeInstituicao}}': this.config.nome,
          '{{classeSelected}}': this.getClasse(this.classeSeleted.id),
          '{{turmaSelected}}': this.turmaSelected.descricao || 'Todas',
          '{{totalDividas}}': this.utilitarios.IntegerToMoneyValueFatura(this.totaisObject.divida),
          '{{mesInicial}}': this.mesSelected.descricao,
          '{{mesFinal}}': this.mesSelected2.descricao,
          '{{author}}': ls.get('nomeUsuario'),
          '{{dataEmissao}}': this.data_hora(),
          '{{dados}}': relatorioDados
        };

        const expressaoRegular = new RegExp(Object.keys(dados).join("|"), "g");
        template = template.replace(expressaoRegular, (match) => dados[match]);

        let options = {
          format: 'A4',
          border: { right: '4mm', left: '4mm' },
          header: { height: '10mm' },
          footer: { height: '1mm' }
        };

        impressaoService.htmlToPdf(template, options);
      } catch (error) {
        this.$store.state.loading_pdf = false;
        this.showError("Erro ao gerar relatório");
      }
    },

    data_hora() {
      const data = new Date();
      return data.toLocaleString('pt-BR');
    },

    async initializeMeses() {
      this.isLoading = true;
      try {
        const response = await axios.get("/listarMesesAllFinancas");
        this.ListaMeses = response.data;
      } catch (error) {
        Swal.fire('Informação', 'Erro ao carregar os meses!', 'error')
      } finally {
        this.isLoading = false;
      }
    },

    async carregarDevedores() {
      try {
        if (!this.camposValidos) {
          Swal.fire('Informação', 'Selecione o Ano lectivo, a classe e os meses para a pesquisa', 'warning')
          return;
        }

        this.isLoading = true;
        const response = await axios.get(
          `/listarDevedoresPropina/${this.anoLectivoSelected.anolectivo}/${this.mesSelected.id_mes}/${this.classeSeleted.id}/${this.mesSelected2.id_mes}`
        );

        this.devedores = response.data.map((devedor) => {
          // Se a multa for 0, o subtotal (divida) é igual ao preço
          if (devedor.descontoMulta == 0) {
            devedor.divida = devedor.precoUnitario;
          }

          // Aplicar desconto percentual ou fixo
          if (devedor.isPercentagem == 1) {
            devedor.divida = this.calcularPercentagem(devedor.valor_desconto, devedor.divida);
          } else {
            devedor.divida = devedor.divida - devedor.valor_desconto;
          }

          return devedor;
        });

        this.devedoresSelected = this.devedores;

        console.log(this.devedores, ' os devedores');


        this.turmasUnicas = [...new Set(this.devedores.map(dev => dev.turma))];
        this.listaTurmas = [
          { id: 1, descricao: "Todas as turmas" },
          ...this.turmasUnicas.map((turma, index) => ({
            id: index + 2,
            descricao: turma
          }))
        ];

        this.turmaSelected = this.listaTurmas[0];
      } catch (error) {
        console.log(error);

        this.showError('Erro ao carregar a lista de devedores');
      } finally {
        this.isLoading = false;
      }
    },


    calcularPercentagem(parte, total) {
      return total - ((parte / 100) * total);
    },


    getClasse(classe) {
      const classes = {
        1: "10ª",
        2: "11ª",
        3: "12ª",
        4: "13ª"
      };
      return classes[classe] || "Inválido";
    },

    limparLista() {
      this.devedores = [];
      this.devedoresSelected = [];
      this.listaTurmas = [];
      this.turmaSelected = null;
      // this.mesSelected = null;
      // this.mesSelected2 = null;
      this.turmasUnicas = [];
    },

    showError(message) {
      Swal.fire("Erro", message, "error");
    },

    showInfo(message) {
      Swal.fire("Informação", message, "info");
    },

    showWarning(message) {
      Swal.fire("Aviso", message, "warning");
    }
  }
};
</script>

<style scoped>
.v-card {
  overflow: hidden;
}

.v-data-table {
  border-radius: 8px;
}

.v-data-table>>>th {
  font-weight: 600 !important;
  background-color: #f5f5f5;
}

.v-data-table>>>.v-data-table__wrapper {
  border-radius: 8px;
}

.total-row {
  background-color: #f5f5f5;
  font-weight: 600;
}

.action-buttons {
  transition: all 0.3s ease;
}

.action-buttons:hover {
  transform: scale(1.1);
}

.rounded-lg {
  border-radius: 8px;
}

.v-alert {
  border-left: 4px solid !important;
}
</style>
